'use client';
import styled from 'styled-components';
import { theme } from '@/components/features/theme/theme';

const Next = ({background, color, hoverBackground, hoverColor, id}) => {
    return (
        <StyledHamNext hoverColor={hoverColor} className="menu-hamburger" id={`${id ? id :'next-button'}`}>
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="20" cy="20" r="20" fill={background ? background :'white'} />
                <circle className={'hover-circle'} cx="20" cy="20" r="0" transform="matrix(-1 0 0 1 40 0)" fill={hoverBackground ? hoverBackground : '#ED2024'} />
                <path d="M14 19C13.4477 19 13 19.4477 13 20C13 20.5523 13.4477 21 14 21V19ZM26.7071 20.7071C27.0976 20.3166 27.0976 19.6834 26.7071 19.2929L20.3431 12.9289C19.9526 12.5384 19.3195 12.5384 18.9289 12.9289C18.5384 13.3195 18.5384 13.9526 18.9289 14.3431L24.5858 20L18.9289 25.6569C18.5384 26.0474 18.5384 26.6805 18.9289 27.0711C19.3195 27.4616 19.9526 27.4616 20.3431 27.0711L26.7071 20.7071ZM14 21H26V19H14V21Z" fill={color ? color :'#152637'} />
            </svg>

        </StyledHamNext>
    );
};
const StyledHamNext = styled.div`
    cursor: pointer;
    transition: ${theme.transition};
    height: 40px;
    width: 40px;
    display: inline-block;

    svg {
        height: 40px;
        width: 40px;

        path {
            transition: ${theme.transition};

        }

        circle {
            transition: ${theme.transition};
        }
    }

    &:hover {
        svg {
            .hover-circle{
                r:20px;
            }
            path {
                fill: ${props => props.hoverColor || theme.colors.white};
                transform: translateX(2px);
            }
        }
    }

`
export default Next;